module.exports = __webpack_public_path__ + "img/ddwu_gallery15.efc33e36.jpg";